import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../../../redux/action';
import MenuSC, { InnerMenuWrapSC, UserTypeMarkSC } from './menu.styled';
import { NavLink, useLocation, withRouter } from 'react-router-dom';
import {
  ROUTE_DASHBOARD,
  ROUTE_MAILBOX,
  // ROUTE_REQUESTS,
  // ROUTE_FAQ,
  ROUTE_INVESTMENTS,
  ROUTE_PROFILE,
  // LS_REFRESH_TOKEN,
  // LS_ACCESS_TOKEN,
  ROUTE_SECONDARY_MARKET,
  ROUTE_GUARANTEE_FUND,
  ROUTE_INVEST_MANAGE_PLAIN,
  ROUTE_EARNINGS_CALCULATOR,
} from '../../../constants';
import { ReactComponent as WishmakerLogo } from '../../../assets/img/svg/logo_outline_white.svg';
import { ReactComponent as WishmakerLogoSmall } from '../../../assets/img/svg/wishmaker-logo-small.svg';
import { ReactComponent as UserIcon } from '../../../assets/img/svg/user.svg';
import { ReactComponent as MobileMenuIcon } from '../../../assets/img/svg/menu.svg';
import { ReactComponent as CloseMenuIcon } from '../../../assets/img/svg/close.svg';
import { ReactComponent as MoreIcon } from '../../../assets/img/svg/more-horizontal.svg';
import { ReactComponent as MailIcon } from '../../../assets/img/svg/icn_mail.svg';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import PropTypes from 'prop-types';
import { BodyText, SmallText } from '../../typography';
import { Link } from 'react-router-dom';
import useWindowSize from '../../../utils/screen-size';
import MobileMenu from '../mobile-menu';
import numeral from 'numeral';

const _Menu = ({ className, userName, userType, logOut, dashboardData, history }) => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isHiddenMenuOpen, setHiddenMenuOpen] = useState(false);
  const { isTablet, isMobile, isNetbook } = useWindowSize();
  const isUserOnboardingInvestor = userType === 'onboarding-investor';
  const isUserOnboardingDebtor = userType === 'onboarding-debtor';
  const isUserOnboardingOnline = userType === 'onboarding-online';
  const isUserInvestor = userType === 'investor' || userType === 'onboarding-investor';
  const isUserRegistered = userType !== 'onboarding-debtor' && userType !== 'onboarding-investor' && userType !== 'onboarding-online';
  const [isProfileMenuOpen, setProfileMenuOpen] = useState(false);
  const profileMenu = useRef();
  const menuTrigger = useRef();

  const hiddenMenu = useRef();
  const hiddenMenuTrigger = useRef();

  const isRegistrationActive = useLocation().pathname === ROUTE_DASHBOARD;

  useEffect(() => {
    document.addEventListener('mousedown', handleOuterClick);
    document.addEventListener('mousedown', handleHiddenClick);
    return () => {
      document.removeEventListener('mousedown', handleOuterClick);
      document.removeEventListener('mousedown', handleHiddenClick);
    };
  }, []);

  const handleHiddenClick = (e) => {
    if (hiddenMenu.current && hiddenMenu.current.contains(e.target)) {
      return;
    } else if (hiddenMenuTrigger.current && hiddenMenuTrigger.current.contains(e.target)) {
      return;
    }
    setHiddenMenuOpen(false);
  };

  const handleOuterClick = (e) => {
    if (profileMenu.current && profileMenu.current.contains(e.target)) {
      return;
    } else if (menuTrigger.current && menuTrigger.current.contains(e.target)) {
      return;
    }
    setProfileMenuOpen(false);
  };

  const onProfileMenuTrigger = () => {
    setProfileMenuOpen(!isProfileMenuOpen);
  };

  const onCloseClick = () => {
    setMobileMenuOpen(false);
  };
  const onCloseHiddenMenu = () => {
    setHiddenMenuOpen(false);
  };
  const onCloseProfileMenu = () => {
    setProfileMenuOpen(false);
  };

  const onLogOutClick = () => {
    setProfileMenuOpen(false);
    logOut();
  };

  const redirectToInvestManage = () => {
    history.push(`${ROUTE_INVEST_MANAGE_PLAIN}/overview`);
  };

  return (
    <MenuSC className={className ? className : null}>
      <InnerMenuWrapSC isOnboarding={isUserOnboardingInvestor}>
        {/* LOGO WRAP */}
        <div className="logo-wrap">
          {isMobile ? (
            <Link to={ROUTE_DASHBOARD} onClick={() => onCloseClick()}>
              <WishmakerLogoSmall />
            </Link>
          ) : (
            <>
              <Link to={ROUTE_DASHBOARD} onClick={() => onCloseClick()}>
                <WishmakerLogo />
              </Link>
              <UserTypeMarkSC className={isUserInvestor ? 'investor' : ''}>
                <span>{isUserInvestor ? 'Investor' : 'Klient'}</span>
              </UserTypeMarkSC>
            </>
          )}
        </div>
        {/* END LOGO WRAP */}

        {isUserOnboardingInvestor ? (
          isTablet ? null : (
            <div className="menu-wrap">
              <NavLink exact to={ROUTE_DASHBOARD} activeClassName="active">
                {isUserOnboardingInvestor && !isRegistrationActive && (
                  <FormattedMessage
                    id="menu_registration"
                    defaultMessage={dlt['menu_registration']}
                  />
                )}
                {!isUserOnboardingInvestor && (
                  <FormattedMessage id="menu_overview" defaultMessage={dlt['menu_overview']} />
                )}
              </NavLink>
              <NavLink exact to={ROUTE_EARNINGS_CALCULATOR} activeClassName="active">
                <FormattedMessage
                  id="menu_earnings_calculator"
                  defaultMessage={dlt['menu_earnings_calculator']}
                />
              </NavLink>
            </div>
          )
        ) : (
          <>
            {/* MENU WRAP */}
            {isTablet ? null : (
              <div className="menu-wrap">
                <NavLink exact to={ROUTE_DASHBOARD} activeClassName="active">
                  {isUserOnboardingDebtor || isUserOnboardingOnline ? (
                    <FormattedMessage
                      id="menu_registration"
                      defaultMessage={dlt['menu_registration']}
                    />
                  ) : (
                    <FormattedMessage
                      id={isUserInvestor ? 'menu_overview' : 'menu_loan_overview'}
                      defaultMessage={
                        isUserInvestor ? dlt['menu_overview'] : dlt['menu_loan_overview']
                      }
                    />
                  )}
                </NavLink>

                {isUserInvestor && isUserRegistered ? (
                  <>
                    <NavLink to={ROUTE_INVESTMENTS} activeClassName="active">
                      <FormattedMessage
                        id="menu_my_investments"
                        defaultMessage={dlt['menu_my_investments']}
                      />
                    </NavLink>
                    <NavLink to={ROUTE_INVEST_MANAGE_PLAIN} activeClassName="active">
                      <FormattedMessage
                        id="menu_investment_manage"
                        defaultMessage={dlt['menu_investment_manage']}
                      />
                    </NavLink>
                  </>
                ) : null}

                {!isNetbook && isUserInvestor && isUserRegistered ? (
                  <>
                    <NavLink
                      exact
                      to={ROUTE_GUARANTEE_FUND}
                      activeClassName="active"
                      onClick={() => onCloseHiddenMenu()}
                    >
                      <FormattedMessage
                        id="menu_guarantee_fund"
                        defaultMessage={dlt['menu_guarantee_fund']}
                      />
                    </NavLink>

                    <NavLink
                      exact
                      to={ROUTE_SECONDARY_MARKET}
                      activeClassName="active"
                      onClick={() => onCloseHiddenMenu()}
                    >
                      <FormattedMessage
                        id="menu_secondary_market"
                        defaultMessage={dlt['menu_secondary_market']}
                      />
                    </NavLink>
                    {/* <NavLink
                  to={ROUTE_REQUESTS}
                  activeClassName="active"
                  onClick={() => onCloseHiddenMenu()}
                >
                  <FormattedMessage id="menu_requests" defaultMessage={dlt['menu_requests']} />
                </NavLink>*/}
                  </>
                ) : null}
                {/*  isUserInvestor && isUserRegistered ?   */}
                {isNetbook && isUserInvestor && isUserRegistered ? (
                  <div className="more-menu">
                    <button
                      onClick={() => setHiddenMenuOpen(!isHiddenMenuOpen)}
                      ref={hiddenMenuTrigger}
                    >
                      <MoreIcon />
                    </button>
                    <div
                      className={isHiddenMenuOpen ? 'hidden-menu active' : 'hidden-menu'}
                      ref={hiddenMenu}
                    >
                      {isNetbook ? (
                        <>
                          <NavLink
                            exact
                            to={ROUTE_GUARANTEE_FUND}
                            activeClassName="active"
                            onClick={() => onCloseHiddenMenu()}
                          >
                            <FormattedMessage
                              id="menu_guarantee_fund"
                              defaultMessage={dlt['menu_guarantee_fund']}
                            />
                          </NavLink>
                        </>
                      ) : null}
                      <NavLink
                        exact
                        to={ROUTE_SECONDARY_MARKET}
                        activeClassName="active"
                        onClick={() => onCloseHiddenMenu()}
                      >
                        <FormattedMessage
                          id="menu_secondary_market"
                          defaultMessage={dlt['menu_secondary_market']}
                        />
                      </NavLink>
                      {/*     <NavLink
                  </NavLink>
                      {/* <NavLink
                    exact
                    to={ROUTE_REQUESTS}
                    activeClassName="active"
                    onClick={() => onCloseHiddenMenu()}
                  >
                    <FormattedMessage id="menu_requests" defaultMessage={dlt['menu_requests']} />
                  </NavLink> */}
                    </div>
                  </div>
                ) : !isUserInvestor &&
                  isUserRegistered /*   <NavLink
                exact
                to={ROUTE_REQUESTS}
                activeClassName="active"
                onClick={() => onCloseHiddenMenu()}
              >
                <FormattedMessage id="menu_requests" defaultMessage={dlt['menu_requests']} />
              </NavLink> */ ? null : null}
              </div>
            )}
            {/* END MENU WRAP */}
          </>
        )}

        {/* USER WRAP */}
        <div className="user-wrap">
          {isUserInvestor && isUserRegistered ? (
            <div className="investor-counts">
              {Object.keys(dashboardData).length !== 0 ? (
                <>
                  <button className="count" onClick={redirectToInvestManage}>
                    <SmallText className="dark-grey">
                      <FormattedMessage
                        id="global_free_sources"
                        defaultMessage={dlt['global_free_sources']}
                      />
                    </SmallText>
                    <BodyText className="white bold">
                      {numeral(
                        Number(dashboardData.balance.free) + Number(dashboardData.balance.tied)
                      ).format('0,00.00')}{' '}
                      €
                    </BodyText>
                  </button>
                  {/* 
                  <div className="count">
                    <SmallText className="dark-grey">
                      <FormattedMessage
                        id="global_guarantee_fund"
                        defaultMessage={dlt['global_guarantee_fund']}
                      />
                    </SmallText>
                    <BodyText className="white bold">
                      {numeral(Number(dashboardData.balance.guaranteeFund)).format('0,00.00')} €
                    </BodyText>
                  </div> */}
                </>
              ) : null}
            </div>
          ) : null}

          {isMobile ? null : (
            <>
              <NavLink
                exact
                to={ROUTE_MAILBOX}
                activeClassName="active"
                style={{
                  marginRight: 16,
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  whiteSpace: 'nowrap'
                }}
              >
                <MailIcon/>
                <span style={{ fontSize: '14px', fontWeight: '500', color: '#F7931E' }}>
                  <FormattedMessage id="menu_mailbox" defaultMessage={dlt['menu_mailbox']} />
                </span>
              </NavLink>
              <button
                className="profile-menu-trigger"
                onClick={() => onProfileMenuTrigger()}
                ref={menuTrigger}
              >
                <UserIcon className="user-icon" />
              </button>
            </>
          )}

          {isTablet ? (
            <button
              className="mobile-menu-trigger"
              onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <CloseMenuIcon /> : <MobileMenuIcon />}
            </button>
          ) : null}

          <div
            className={isProfileMenuOpen ? 'profile-menu active' : 'profile-menu'}
            ref={profileMenu}
          >
            {isUserRegistered ? (
              <NavLink
                exact
                to={ROUTE_PROFILE}
                activeClassName="active"
                onClick={() => onCloseProfileMenu()}
              >
                <FormattedMessage id="menu_profile" defaultMessage={dlt['menu_profile']} />
              </NavLink>
            ) : null}

            <button onClick={() => onLogOutClick()}>
              <FormattedMessage id="global_log_out" defaultMessage={dlt['global_log_out']} />
            </button>
          </div>
        </div>

        {/* END USER WRAP */}
      </InnerMenuWrapSC>

      <MobileMenu
        userName={userName}
        isMobileMenuOpen={isMobileMenuOpen}
        isUserRegistered={isUserRegistered}
        isUserInvestor={isUserInvestor}
        isUserOnboardingInvestor={isUserOnboardingInvestor}
        isUserOnboardingDebtor={isUserOnboardingDebtor}
        isUserOnboardingOnline={isUserOnboardingOnline}
        onCloseClick={() => onCloseClick()}
        onLogout={() => onLogOutClick()}
      />
    </MenuSC>
  );
};

_Menu.propTypes = {
  className: PropTypes.string,
};

_Menu.defaultProps = {
  className: '',
};

const mapStateToProps = (state) => {
  return {
    userType: state.user.type,
    userName: state.user.wm_number,
    dashboardData: state.dashboard,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      logOut: ActionCreators.logOut,
    },
    dispatch
  );
};

const Menu = withRouter(connect(mapStateToProps, mapDispatchToProps)(_Menu));
export default Menu;
